export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/visual-cues-icon.svg?1c7fb255cef059f066abd7eaef800c6b";